<template>
  <div class="invoice">
    <van-nav-bar
      :title="$t('invoice.title')"
      left-arrow
      fixed
      @click-left="$router.push('/ShopSet/' + sessionStorage.actShopId)"
    >
      <van-button type="primary" color="#1989fa" slot="right" @click="saveBtn">
        {{ $t("PackageDish.save") }}
      </van-button>
      <van-button
        type="danger"
        style="margin-left:25px;"
        slot="right"
        @click="deleteInvoiceStore"
      >
        {{ $t("ShopList.delete") }}
      </van-button>
    </van-nav-bar>
    <van-cell-group>
      <van-field
        v-model="info.businessid"
        :label="$t('invoice.unifiedNumber')"
        clearable
        :placeholder="$t('invoice.pleaseInput') + $t('invoice.unifiedNumber')"
      />
      <van-field
        v-model="info.posno"
        label="$t('invoice.postMachineCode')"
        clearable
        :placeholder="$t('invoice.pleaseInput') + $t('invoice.postMachineCode')"
      />
      <van-field
        v-model="info.pid"
        :label="$t('invoice.postMachineSerialNumber')"
        clearable
        :placeholder="
          $t('invoice.pleaseInput') + $t('invoice.postMachineSerialNumber')
        "
      />
      <van-field
        v-model="info.pname"
        label="$t('invoice.productName')"
        clearable
        :placeholder="$t('invoice.pleaseInput') + $t('invoice.productName')"
      />
      <van-field
        v-model="info.rid"
        :label="$t('invoice.authenticator')"
        clearable
        :placeholder="$t('invoice.pleaseInput') + $t('invoice.authenticator')"
      />
      <van-field
        v-model="info.branchno"
        :label="$t('invoice.storeCode')"
        clearable
        :placeholder="$t('invoice.pleaseInput') + $t('invoice.storeCode')"
      />
    </van-cell-group>
  </div>
</template>

<script>
export default {
  data() {
    return {
      info: {
        store_id: sessionStorage.actShopId,
        businessid: "",
        posno: "",
        pid: "",
        pname: "",
        rid: "",
        branchno: ""
      },
      invoice_id: ""
    };
  },
  async mounted() {
    await this.getInvoiceList();
  },
  methods: {
    // 保存按钮
    saveBtn() {
      if (this.invoice_id) {
        this.updateInvoiceStore();
      } else {
        this.createInvoiceStore();
      }
    },
    // 创建发票资料
    createInvoiceStore() {
      this.$axios({
        method: "post",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/invoice/store",
        data: this.info
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.$toast({
              type: "success",
              message: res.data.message
            });
            this.getInvoiceList();
          } else {
            this.$toast({
              type: "fail",
              message: res.data.error
            });
          }
        })
        .catch(err => {
          console.log(err);
          this.$toast({
            type: "fail",
            message: this.$t("center.message")
          });
        });
    },
    // 获取发票资料列表
    getInvoiceList() {
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/invoice/lists",
        params: {
          store_id: sessionStorage.actShopId
        }
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            console.log(res.data.data);

            if (res.data.data.id) {
              this.invoice_id = res.data.data.id;
              this.getInvoiceDetail();
            }
          }
        })
        .catch(err => {
          console.log(err);
          this.$toast({
            type: "fail",
            message: this.$t("center.message")
          });
        });
    },
    // 发票资料详情
    getInvoiceDetail() {
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + `/api/invoice/${this.invoice_id}/index`
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.info = res.data.data;
          }
        })
        .catch(err => {
          console.log(err);
          this.$toast({
            type: "fail",
            message: this.$t("center.message")
          });
        });
    },
    // 修改发票资料
    updateInvoiceStore() {
      this.info.id = this.invoice_id;
      console.log(this.info);

      this.$axios({
        method: "patch",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/invoice/update",
        data: this.info
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.$toast({
              type: "success",
              message: res.data.message
            });
          }
        })
        .catch(err => {
          console.log(err);
          this.$toast({
            type: "fail",
            message: this.$t("center.message")
          });
        });
    },
    // 删除发票资料
    deleteInvoiceStore() {
      this.$axios({
        method: "delete",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + `/api/invoice/${this.invoice_id}/destroy`
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.$toast({
              type: "success",
              message: res.data.message
            });
            this.info = {
              store_id: sessionStorage.actShopId,
              businessid: "",
              posno: "",
              pid: "",
              pname: "",
              rid: "",
              branchno: ""
            };
          }
        })
        .catch(err => {
          console.log(err);
          this.$toast({
            type: "fail",
            message: this.$t("center.message")
          });
        });
    }
  }
};
</script>

<style scoped>
/deep/ .van-nav-bar .van-icon {
  font-size: 24px;
  color: #fff;
}
/deep/ .van-field__left-icon .van-icon {
  font-size: 30px;
}
/deep/ .van-cell .van-icon {
  font-size: 30px;
}
/deep/ .van-cell .van-icon-clear {
  font-size: 24px;
}
/deep/ .van-uploader__preview-delete-icon {
  top: -9px;
  right: -8px;
}
/deep/ .van-field__label {
  width: 110px;
}
/deep/ .amountExempt .van-field__label {
  width: 150px;
}
/deep/ .van-switch {
  float: right;
}
/deep/ .van-picker__cancel,
/deep/ .van-picker__confirm {
  color: #2f75f4;
}
/deep/ .van-image {
  font-size: 28px;
  vertical-align: top;
}
/deep/ .colorSelect .van-field__control {
  color: #fff;
  padding-left: 10px;
  line-height: 30px;
}
/deep/ .van-button {
  height: 35px;
}
.invoice {
  width: 100%;
  height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/Shop/invoice.vue